import { EmployeeType } from '@/common/types';

export const userTypeCode: Record<EmployeeType, string> = {
  broker: 'EMPLOYEE',
  office: 'OFFICE',
  company: 'FRANCHISE',
};
